import React from 'react';
import { ReactHint } from '../components/components';
import { ColorSelection } from './dialogs';
import { MDCAnchorMenu, MDCPopOver, MDCMenu, MDCDialog, MDCFormSwitch, MDCIconTextInput } from '../components/mdc-components';
export class ToolbarFormatMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return /*#__PURE__*/React.createElement(ToolbarMenu, {
      label: "Format",
      onMenuSelected: this.props.onMenuSelected.bind(this),
      id: "format"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "formatblock",
      "data-value": "h2"
    }, "Title 2"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "formatblock",
      "data-value": "h3"
    }, "Title 3"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "formatblock",
      "data-value": "h4"
    }, "Title 4"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "formatblock",
      "data-value": "h5"
    }, "Title 5"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "formatblock",
      "data-value": "h6"
    }, "Title 6"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "formatblock",
      "data-value": "p"
    }, "Paragraph"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "formatblock",
      "data-value": "pre"
    }, "Preformatted"));
  }

}
export class ToolbarEditMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return /*#__PURE__*/React.createElement(ToolbarMenu, {
      label: "Edit",
      onMenuSelected: this.props.onMenuSelected,
      id: "edit"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "copy"
    }, "Copy"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "cut"
    }, "Cut"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "clean"
    }, "Clean Selection"));
  }

}
export class ToolbarMediaMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return /*#__PURE__*/React.createElement(ToolbarMenu, {
      label: "Media",
      onMenuSelected: this.props.onMediaSelected,
      id: "media"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "image"
    }, "Add Image"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "video"
    }, "Add Youtube Video"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-command": "tweet"
    }, "Add Tweet"));
  }

}
export class ToolbarColorPicker extends React.Component {
  constructor(props) {
    super(props);
    var defaultColors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FF9800', '#FF5722', '#795548', '#9E9E9E', "#d38cac", "#8b8b8b", "#CAA56C"];
    if (this.props.colors) this.colors = this.props.colors.split(',');else this.colors = defaultColors;

    if (this.props.addColors) {
      var addColors = this.props.addColors.split(',');
      this.colors = this.colors.concat(addColors);
    }
  }

  onColorClick(event) {
    if (this.props.onColorSelect) {
      var target = event.target;
      var color = target.dataset.color;
      this.props.onColorSelect(color);
    }
  }

  onMouseDown(event) {
    event.preventDefault();
  }

  render() {
    var icon = this.props.icon;
    if (!icon) icon = 'format_color_text';
    var id = this.props.id;
    if (!id) id = 'color-picker';
    var hint = this.props.hint;
    if (!hint) hint = 'Color';
    var colorNodes = this.colors.map(color => {
      return /*#__PURE__*/React.createElement(ColorSelection, {
        color: color,
        key: color
      });
    });
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: id
    }, /*#__PURE__*/React.createElement("div", {
      className: "toolbar-button",
      "data-anchor": true,
      tabIndex: "0"
    }, /*#__PURE__*/React.createElement(ReactHint, {
      events: true,
      position: "bottom"
    }), /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      "data-rh": hint
    }, icon)), /*#__PURE__*/React.createElement(MDCPopOver, {
      id: id,
      disableInit: "true"
    }, /*#__PURE__*/React.createElement("div", {
      className: "color-picker-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-colors",
      onClick: this.onColorClick.bind(this),
      onMouseDown: this.onMouseDown.bind(this)
    }, colorNodes))));
  }

}
export class ToolbarMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  onMenuSelected(event) {
    if (this.props.onMenuSelected) this.props.onMenuSelected(event);
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "toolbar-menu"
    }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      onMenuSelected: this.onMenuSelected.bind(this),
      menuId: this.props.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "toolbar-menu-anchor",
      "data-anchor": true,
      tabIndex: "0"
    }, /*#__PURE__*/React.createElement("span", null, this.props.label), /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "keyboard_arrow_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, this.props.children)));
  }

}
export class ToolbarLink extends React.Component {
  constructor(props) {
    super(props);
  }

  onClick(event) {
    if (this.props.onSaveSelection) this.props.onSaveSelection();
    this.dialog.show();
  }

  onMouseDown(event) {
    event.preventDefault();
  }

  onDialogAccept() {
    var url = this.input.value;
    this.input.value = '';

    if (this.props.onDialogAccept) {
      this.props.onDialogAccept(url);
    }
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "toolbar-button"
    }, /*#__PURE__*/React.createElement(MDCDialog, {
      ref: ref => this.dialog = ref,
      onDialogAccept: this.onDialogAccept.bind(this)
    }, /*#__PURE__*/React.createElement(MDCIconTextInput, {
      icon: "link",
      label: "Link",
      id: "link",
      ref: ref => this.input = ref
    })), /*#__PURE__*/React.createElement(ReactHint, {
      events: true,
      position: "bottom"
    }), /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      "data-rh": "Add Link",
      onClick: this.onClick.bind(this),
      onMouseDown: this.onMouseDown.bind(this)
    }, "insert_link"));
  }

}
export class ToolbarSeparator extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "separator"
    });
  }

}
export class ToolbarButton extends React.Component {
  constructor(props) {
    super(props);
  }

  onClick(event) {
    if (this.props.onButtonClick) this.props.onButtonClick({
      command: this.props.command,
      value: this.props.value
    });
  }

  onMouseDown(event) {
    event.preventDefault();
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "toolbar-button",
      onClick: this.onClick.bind(this),
      onMouseDown: this.onMouseDown.bind(this)
    }, /*#__PURE__*/React.createElement(ReactHint, {
      events: true,
      position: "bottom"
    }), /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      "data-rh": this.props.hint
    }, this.props.icon));
  }

}
export class ToolbarHideButton extends React.Component {
  constructor(props) {
    super(props);
  }

  onClick(event) {
    if (this.props.onToolbarHide) this.props.onToolbarHide();
  }

  onMouseDown(event) {
    event.preventDefault();
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "toolbar-button",
      onClick: this.onClick.bind(this),
      onMouseDown: this.onMouseDown.bind(this)
    }, /*#__PURE__*/React.createElement(ReactHint, {
      events: true,
      position: "bottom"
    }), /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      "data-rh": "Hide"
    }, "close"));
  }

}
export class ToolbarButtonGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "toolbar-button-group"
    }, this.props.children);
  }

}
export class EditorToolbar extends React.Component {
  constructor(props) {
    super(props);
  }

  setFocus() {
    this.element.classList.add('active');
    if (this.props.onToolbarActive) this.props.onToolbarActive();
  }

  removeFocus() {}

  hide() {
    this.element.classList.remove('active');
  }

  render() {
    var cls = 'rich-editor-toolbar';
    if (this.props.cls) cls += ' ' + this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: "rich-editor-toolbar-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: cls,
      tabIndex: "0",
      ref: ref => this.element = ref
    }, this.props.children));
  }

}
export class ToolbarDefaultButtonGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  onButtonClick(event) {
    this.props.onButtonClick(event);
  }

  render() {
    return /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "undo",
      hint: "Undo",
      command: "undo",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "redo",
      hint: "Redo",
      command: "redo",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_clear",
      hint: "Clear Formatting",
      command: "removeFormat",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarHideButton, {
      onToolbarHide: this.props.onToolbarHide
    }), /*#__PURE__*/React.createElement(ToolbarSeparator, null), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_bold",
      hint: "Bold",
      command: "bold",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_underlined",
      hint: "Underline",
      command: "underline",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_italic",
      hint: "Italic",
      command: "italic",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarSeparator, null), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_align_left",
      hint: "Left Align",
      command: "justifyLeft",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_align_right",
      hint: "Right Align",
      command: "justifyRight",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_align_center",
      hint: "Center Align",
      command: "justifyCenter",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_quote",
      hint: "Quote",
      command: "formatBlock",
      value: "blockquote",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_list_numbered",
      hint: "Numbered List",
      command: "insertorderedlist",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_list_bulleted",
      hint: "Bullet List",
      command: "insertunorderedlist",
      onButtonClick: this.onButtonClick.bind(this)
    }));
  }

}
export class ToolbarTinyButtonGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  onButtonClick(event) {
    this.props.onButtonClick(event);
  }

  onWordFormatClick(event) {
    this.props.onWordFormatClick(event);
  }

  onColorSelect(color) {
    this.props.onColorSelect(color);
  }

  onCreateLink(url) {
    this.props.onCreateLink(url);
  }

  onSaveSelection() {
    this.props.onSaveSelection();
  }

  render() {
    return /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "undo",
      hint: "Undo",
      command: "undo",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "redo",
      hint: "Redo",
      command: "redo",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_clear",
      hint: "Clear Formatting",
      command: "removeFormat",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "functions",
      hint: "Clean Word",
      onButtonClick: this.onWordFormatClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarHideButton, {
      onToolbarHide: this.props.onToolbarHide
    }), /*#__PURE__*/React.createElement(ToolbarSeparator, null), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_bold",
      hint: "Bold",
      command: "bold",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_underlined",
      hint: "Underline",
      command: "underline",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_italic",
      hint: "Italic",
      command: "italic",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarSeparator, null), /*#__PURE__*/React.createElement(ToolbarColorPicker, {
      onColorSelect: this.onColorSelect.bind(this),
      addColors: this.props.addColors
    }), /*#__PURE__*/React.createElement(ToolbarLink, {
      onDialogAccept: this.onCreateLink.bind(this),
      onSaveSelection: this.onSaveSelection.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarSeparator, null), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_quote",
      hint: "Quote",
      command: "formatBlock",
      value: "blockquote",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_list_numbered",
      hint: "Numbered List",
      command: "insertorderedlist",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_list_bulleted",
      hint: "Bullet List",
      command: "insertunorderedlist",
      onButtonClick: this.onButtonClick.bind(this)
    }));
  }

}
export class ToolbarMinimalButtonGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  onButtonClick(event) {
    console.log('button click');
    this.props.onButtonClick(event);
  }

  onColorSelect(color) {
    this.props.onColorSelect(color);
  }

  onCreateLink(url) {
    this.props.onCreateLink(url);
  }

  onSaveSelection() {
    this.props.onSaveSelection();
  }

  onHtmlCheckedChange(checked) {
    this.props.onHtmlCheckedChange(checked);
  }

  render() {
    return /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "undo",
      hint: "Undo",
      command: "undo",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "redo",
      hint: "Redo",
      command: "redo",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_clear",
      hint: "Clear Formatting",
      command: "removeFormat",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarHideButton, {
      onToolbarHide: this.props.onToolbarHide
    }), /*#__PURE__*/React.createElement(ToolbarButton, {
      icon: "format_bold",
      hint: "Bold",
      command: "bold",
      onButtonClick: this.onButtonClick.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarSeparator, null), /*#__PURE__*/React.createElement(ToolbarColorPicker, {
      onColorSelect: this.onColorSelect.bind(this),
      addColors: this.props.addColors
    }), /*#__PURE__*/React.createElement(ToolbarLink, {
      onDialogAccept: this.onCreateLink.bind(this),
      onSaveSelection: this.onSaveSelection.bind(this)
    }), /*#__PURE__*/React.createElement(ToolbarSeparator, null), /*#__PURE__*/React.createElement(MDCFormSwitch, {
      label: "html",
      onCheckedChange: this.onHtmlCheckedChange.bind(this)
    }));
  }

}
export default {
  ToolbarFormatMenu,
  ToolbarEditMenu,
  ToolbarMediaMenu,
  ToolbarColorPicker,
  ToolbarMenu,
  ToolbarLink,
  ToolbarSeparator,
  ToolbarButton,
  ToolbarHideButton,
  ToolbarButtonGroup,
  EditorToolbar,
  ToolbarDefaultButtonGroup,
  ToolbarTinyButtonGroup,
  ToolbarMinimalButtonGroup
};